import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { EditActionContext } from "./EditActionContext";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

function useGet(modelConfig: any) {
  const { setElement, setBackendFormErrors, setShowModal } = useContext(EditActionContext);
  const { setChanged } = useContext(ChangeDectionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get(modelConfig.endpoint, id, '?relations=pets')
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setBackendFormErrors({});
        setShowModal(true);
        setTimeout(() => {
          setChanged(false, data);
        }, 3000);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
